export default {
  impressionId: '7c5889b4-ef4e-4b81-8cf6-288686a94430',
  sessionId: null,
  clientIp: '1.1.1.1',
  agentId: '2010000',
  questions: {
    '1987': {
      productLines: ['ECONOMY'],
      text: 'Will any applicant be eligible for Medicare on the requested effective date?',
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4253': 'no', '4254': 'yes' },
      expectedAnswers: [4253],
      openOptions: []
    },
    '1988': {
      productLines: ['ECONOMY'],
      text: 'Will more than one short term medical insurance policy or certificate underwritten by Companion Life Insurance Company be in force at the same time as this coverage?',
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4256': 'yes', '4255': 'no' },
      expectedAnswers: [4255],
      openOptions: []
    },
    '1989': {
      productLines: ['ECONOMY'],
      text: 'Have/Are you, or any applicant:',
      subText:
        'An expectant parent, in process of adoption or undergoing infertility treatment?\r\nOver 300 pounds if male or over 250 pounds if female?\r\nIn the past 12 months, been advised by a medical professional to have diagnostic testing, treatment, surgery that has not yet been completed?\r\nCurrently hospitalized, bed bound, or confined in a medical facility for any reason?',
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4257': 'no', '4258': 'yes' },
      expectedAnswers: [4257],
      openOptions: []
    },
    '1990': {
      productLines: ['ECONOMY'],
      text: 'Within the last 5 years has any applicant had a diagnosis, symptoms, an abnormal test result or received treatment, medication or consultation for:',
      subText:
        "cancer, Hodgkin's or Non-Hodgkin's lymphoma or malignant melanoma (excluding basal cell);\r\natrial fibrillation, abnormal heart rhythm, a heart disorder, angina, heart attack or congestive heart failure;\r\nstroke;\r\ntransient ischemic attacks (TIAs);\r\nuncontrolled hypertension (blood pressure greater than 160/95);\r\nType 1 diabetes or diabetes requiring insulin or oral medications;\r\nCrohn's disease or ulcerative colitis;\r\nhepatitis C or liver or kidney disorders (excluding kidney stones);\r\norgan or bone marrow transplants;\r\nchronic obstructive pulmonary disease (COPD) or emphysema;\r\ninflammatory arthritis;\r\nSystemic Lupus Erythematosus (SLE) or degenerative spine or hip disorders;\r\nhemophilia, leukemia;\r\nmuscular dystrophy or multiple sclerosis;\r\nLou Gehrig disease (ALS);\r\nalcohol or drug abuse or misuse;\r\nbipolar, schizophrenia;\r\nor eating disorders?",
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4259': 'no', '4260': 'yes' },
      expectedAnswers: [4259],
      openOptions: []
    },
    '1991': {
      productLines: ['ECONOMY'],
      text: 'Within the last 5 years has any applicant been diagnosed or treated by a physician or medical practitioner for Aquired Immune Deficiency Syndrome (AIDS) or tested positive for Human Immunodeficiency Virus (HIV)? (Residents of Wisconsin do not need to disclose HIV or test results).',
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4261': 'no', '4262': 'yes' },
      expectedAnswers: [4261],
      openOptions: []
    },
    '1992': {
      productLines: ['ECONOMY'],
      text: 'If all persons to be insured are United States citizens, please answer "No" to this question. <br> If any person to be insured is not a United States citizen, has that person resided outside the United States during the last 4 months?',
      subText: '',
      warnings: [
        'Unfortunately, you do not meet the eligibility requirements for coverage.'
      ],
      possibleAnswers: { '4263': 'no', '4264': 'yes' },
      expectedAnswers: [4263],
      openOptions: []
    }
  },
  optionalQuestions: {}
}
